import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Product'

  }
];

@Component({
  selector: 'page-product',
  templateUrl: './product.html',
  styleUrls: ['./product.scss']
})

export class PageProduct implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  customerCtrl: FormControl;
  fetchCustomer=[];
  filteredCustomers: any;
  customers = [];
  rows = [];
  temp = [];
  model=[];
  selected=[];
  key:any="";keypart:any="";
  productCtrl:FormControl;
  productModels=[];
  filteredProducts:any;
  print="";
  loadingIndicator: boolean = true;
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/product-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/product-list-export.php";
  constructor(private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
   
    this.getCustomer();
    this.getProduct();
    this.getStartData();
   // console.log('-------this.filteredStates-----',this.filteredStates);
    this._sharedService.emitChange(this.pageTitle);
  }

  onSelect({ selected }) {
    console.log('Select Event', this.selected);
   
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  openPrint(){
    for(let i=0;i<this.selected.length;i++){
          
              //console.log('----select---',this.selected[i]['tma_id'],this.selected);
              if(this.selected[i]['tp_id']!="undefined"){
              this.print+="&print[]="+this.selected[i]['tp_id'];
      }    
    }
    let popupWinindow
    popupWinindow = window.open( environment.url+'/api/print-product.php?'+this.print, '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no width=auto');
    this.selected = [];
    this.print="";
    
    }

  getStartData(){
    this.httpservice.fetchget('getJSON_product.php?keypart='+this.keypart+'&key='+this.key,(data)=>{
      this.temp = [...data];
      this.rows = data;
      this.loadingIndicator = false;
});
  }


  getCustomer(){
    this.httpservice.fetchget('getJSON_customer_name.php?',(data)=>{
      this.customers = data.map(function (val) {
        return [val.tc_company_shortname]
      });
    });


    this.customerCtrl = new FormControl();
    this.filteredCustomers = this.customerCtrl.valueChanges
    .startWith(null)
    .map(val=>{
      if(isArray(val)){
        this.key=val[0];
      }else{
        this.key=val;
      }
     
      return val ? this.customers.filter((s) => new RegExp(val, 'gi').test(s)) : this.customers;
    });
    
  }

  getProduct(){
    this.httpservice.fetchget('getJSON_product.php?',(productModel) => {
      this.productModels = productModel.map(function (val) {
        return [val.tp_part_no]
      });
      console.log('------this.product------', this.productModels);
    });
    this.productCtrl = new FormControl();
    this.filteredProducts = this.productCtrl.valueChanges
    .startWith(null)
    .map(val => {

      if (isArray(val)) {
        this.keypart = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.keypart = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.productModels.filter((s) => new RegExp(val, 'gi').test(s)) : this.productModels;
    });
  }



  disableProduct(tp_id:string){
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/disableProduct.php?tp_id='+tp_id);
    req.onload = () => {
      console.log('---delect status ---',JSON.parse(req.response),tp_id);
      //JSON.parse(req.response);
    };
    req.send();
    for(let i=0;i<2;i++){
      this.search();
    }
  }
  edit(tp_id:string){
    console.log('----ID----',tp_id);
    this.router.navigateByUrl('default-layout/product-form-edit/'+tp_id);
  }

  fetch(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_product.php?key='+this.key[0]);

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

search(){ 
  this.httpservice.fetchget('getJSON_product.php?keypart='+this.keypart+'&key='+this.key,(data)=>{
          this.temp = [...data];
          this.rows = data;
          setTimeout(() => { this.loadingIndicator = false; }, 1500);
  });
  this.productCtrl.reset();
  this.customerCtrl.reset();
  this.key="";
  this.keypart="";
  }

  ngOnInit() {


  }


    openDialog(tp_id:string) {
    
    let dialogRef = this.dialog.open(ProductDiableDialog);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
        this.disableProduct(tp_id);
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }

    });
  }

    updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      
      return d.tp_part_no.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
  }

  updateFilter_(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      
      return d.tcp_name.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
  }

  
}
//dialog
@Component({
  selector: 'product-dialog',
  templateUrl: 'product-dialog.html',
})
export class ProductDiableDialog {
  jazzMessage = 'Jazzy jazz jazz';
  constructor(public dialogRef: MdDialogRef<ProductDiableDialog>) {}
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/product/product.ts